import { useEffect } from 'react';

interface UseIsScrollCompletedProps {
  isEnabled?: boolean;
  onComplete: () => void;
  targetScrollY: number;
  threshold?: number;
}

/**
 * Custom hook to call a function once the scroll to provided target location is completed
 */
const useIsScrollCompleted = ({
  isEnabled = true,
  targetScrollY,
  threshold = 2,
  onComplete,
}: UseIsScrollCompletedProps) => {
  useEffect(() => {
    if (!window || !isEnabled) return;

    const checkInterval = setInterval(() => {
      const distance = Math.abs(window.scrollY - targetScrollY);

      if (distance < threshold || targetScrollY === 0) {
        onComplete();
        clearInterval(checkInterval);
      }
    }, 25);

    const timeout = setTimeout(() => clearInterval(checkInterval), 2000);

    return () => {
      clearInterval(checkInterval);
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetScrollY, threshold, onComplete, isEnabled]);
};

export default useIsScrollCompleted;
